import axios from './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './assets/scss/index.scss'
import { checkI18n } from './plugins/i18n'
import { Tools } from './plugins/tools'
// import 'amfe-flexible'
import config from './config'

const app = createApp(App)

app.config.globalProperties.$axios = axios
app.config.globalProperties.$checkI18n = checkI18n
app.config.globalProperties.$tools = Tools
app.config.globalProperties.$config = config

// 加载所有皮肤
const requireComponents = require.context('./components/SkinSlot', true, /\.vue/)

requireComponents.keys().forEach(fileName => {
  // 组件实例
  const reqCom = requireComponents(fileName)
  // 截取路径作为组件名
  const reqComName = fileName.split('/')[1].replace(/(.*)\.vue$/, '$1')
  // 组件挂载
  app.component(reqComName, reqCom.default || reqCom)
})

app.use(i18n).use(store).use(router).mount('#app')
